import React, { forwardRef } from "react";
import { FieldTypes } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import AcunetixPremiumMappingForm from "./AcunetixPremiumMappingForm";

interface GenericPullCredentialsFormProps {
  fields: { name: string; label: string; required: boolean; type?: string }[];
  versionField: boolean;
  MappingForm: React.ComponentType<any>;
}

const AcunetixPremiumCredentialsForm: React.ForwardRefRenderFunction<
  GenericPullCredentialsFormProps,
  any
> = (props, ref) => {
  const fields: {
    name: string;
    label: string;
    required: boolean;
    type?: string;
    help?: string;
  }[] = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: false,
      help: "If you are using online.acunetix.com, the API Endpoint is https://online.acunetix.com/api\nIf you are using app.invicti.com, the API Endpoint is https://app.invicti.com/api\nIf you are using app-eu.invicti.com, the API Endpoint is https://app-eu.invicti.com/api",
    },
    {
      name: "token",
      label: "Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      versionField={false}
      MappingForm={AcunetixPremiumMappingForm as React.ComponentType<any>}
    />
  );
};
export default forwardRef(AcunetixPremiumCredentialsForm);
